"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("./_internal/Icon"));
var NormalFileOutlined = /*#__PURE__*/_react["default"].forwardRef(function (ddProps, ref) {
  var props = {};
  var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    className: "dt__icon",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M186.816 101.483C211.84 76.5 241.984 64 277.333 64H638.08c20.95 0 40.704 4.843 59.285 14.55a126.187 126.187 0 0145.782 40.362l129.92 186.752c8.042 11.563 13.973 23.787 17.792 36.672a42.453 42.453 0 014.757 26.112 137.3 137.3 0 01.384 10.304V832c0 35.35-12.501 65.515-37.483 90.517C833.493 947.5 803.35 960 768 960H277.333c-35.349 0-65.514-12.501-90.517-37.483-24.981-25.024-37.483-55.168-37.483-90.517V192c0-35.35 12.502-65.515 37.483-90.517zM779.093 320L673.11 167.637a54.485 54.485 0 00-1.109-1.536V320h107.093zM586.667 149.333H277.333c-11.776 0-21.845 4.16-30.165 12.502-8.32 8.32-12.501 18.389-12.501 30.165v640c0 11.776 4.16 21.845 12.501 30.165 8.32 8.32 18.39 12.502 30.165 12.502H768c11.776 0 21.845-4.16 30.165-12.502 8.32-8.32 12.502-18.389 12.502-30.165V405.333H629.333a42.667 42.667 0 01-42.666-42.666V149.333zm10.666 661.334h-256a42.667 42.667 0 110-85.334h256a42.667 42.667 0 110 85.334z"
  }));
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, ddProps, {
    svg: svg,
    ref: ref
  }));
});
NormalFileOutlined.displayName = "NormalFileOutlined";
var _default = exports["default"] = NormalFileOutlined;